import PropTypes from 'prop-types';
import React from 'react';
import Switch from '@material-ui/core/Switch';
import Tooltip from '@material-ui/core/Tooltip';

// API Doc - https://mui.com/api/switch/
export default function ToggleColumn({ row, col, cell }) {
  const handleChange = (e) => {
    const { onClick } = col.columnConfig;
    onClick(row, e.target.checked);
  };
  const renderSwitch = ({ col, cell }) => {
    return (
      <Switch
        checked={!!cell.value}
        onChange={handleChange}
        color={col.columnConfig.color || 'primary'}
        disabled={cell?.isColumnDisabled || cell.isDisabled || cell.disabled}
      />
    );
  };
  return cell.tooltipText ? (
    <Tooltip arrow title={cell.tooltipText} placement="bottom">
      <span>{renderSwitch({ col, cell })}</span>
    </Tooltip>
  ) : (
    renderSwitch({ col, cell })
  );
}
ToggleColumn.propTypes = {
  row: PropTypes.object.isRequired, // row data
  col: PropTypes.shape({
    // column config
    columnConfig: PropTypes.shape({
      onClick: PropTypes.func.isRequired, // (row, value) :=> {}
      color: PropTypes.oneOf(['default', 'primary', 'secondary', 'error', 'info', 'success', 'warning']),
    }).isRequired,
  }).isRequired,
  cell: PropTypes.shape({
    value: PropTypes.any,
    isDisabled: PropTypes.bool,
  }).isRequired,
};
